import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {ASync} from "../PA.Core/Basic/ASync";
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_DistribChannelRow,
    WB_DivisionRow,
    WB_MasterDataSetRow,
    WB_ProductHierarchyLevelRow,
    WB_ProductHierarchyRow, WB_ProductHierarchySalesAreaRow, WB_SalesAreaRow, WB_SalesOrgRow, WB_SourceRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbProductHierarchy} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_DistribChannel,
    esWB_Division,  esWB_MasterData_Set,
    esWB_Product_Hierarchy,
    esWB_Product_Hierarchy_Level, esWB_Product_Hierarchy_SalesArea, esWB_SalesArea, esWB_SalesOrg, esWB_Source
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {
    CreateOptions,
    ESRecordResolver
} from "../PA.Core/lib/ESRecordResolver";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {BehaviorSubject} from "rxjs";
import {ProductHierarchyBOValidations} from "./ProductHierarchyBO.Validations";

export class ProductHierarchyBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_ProductHierarchy: WB_ProductHierarchyRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New ProductHierarchy'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_ProductHierarchy = null;
        this.IHaveSalesAreas_init();

    }

    get WB_ProductHierarchy(): WB_ProductHierarchyRow
    {
        return this.drWB_ProductHierarchy;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating ProductHierarchy");
        let internalOnComplete = this._OnLoadComplete = (async () => {
            try {
            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new ProductHierarchy.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                return self;
            }

            // Create record using dbContext
            let newProductHierarchyRow: WB_ProductHierarchyRow = <WB_ProductHierarchyRow> await  self.dbContext.createRecordWithKey(esWB_Product_Hierarchy)
            newProductHierarchyRow.setDefaults()
            self.drWB_ProductHierarchy = newProductHierarchyRow;
            self.dbContext.add(esWB_Product_Hierarchy, newProductHierarchyRow)
            self.Identity.setAll(self.WB_ProductHierarchy.cif.WB_PRDH_ID, self.WB_ProductHierarchy.cif.WB_PRD_HIER_ID, self.WB_ProductHierarchy.cif.WB_PRD_HIER_NAME);
            self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
            self.Identity.listenToRecordUpdates(self.WB_ProductHierarchy, 'WB_PRDH_ID','WB_PRD_HIER_ID','WB_PRD_HIER_NAME')

            await self.applyCreateOptions()
            self.Identity.setAll(self.WB_ProductHierarchy.cif.WB_PRDH_ID, self.WB_ProductHierarchy.cif.WB_PRD_HIER_ID, self.WB_ProductHierarchy.cif.WB_PRD_HIER_NAME);
            self.LoadProgressProvider.finish();
            self._bIsLoaded = true;
            self._OnLoadComplete = null;
            return self
            }
            catch(err){
                self.LoadProgressProvider.exception(err)
              return self
            }

        })();

        return internalOnComplete;
    }

    async applyCreateOptions(){
        const self = this
        let sId = self.CreateOptions?.sId || self.LoadOptions?.sId
        if (!_.isEmpty(sId))
            self.WB_ProductHierarchy.cif.WB_PRD_HIER_ID = sId

        let sName = self.CreateOptions?.sName || self.LoadOptions?.sName
        if (!_.isEmpty(sName))
            self.WB_ProductHierarchy.cif.WB_PRD_HIER_NAME = sName

        // Set Master Data Set
        let wbMasterDataSet = self.CreateOptions?.wbMasterDataSetId || self.LoadOptions?.wbMasterDataSetId
        if (_.isNumber(wbMasterDataSet)) {
            let mds: WB_MasterDataSetRow = <any>await self.dbContext.find(esWB_MasterData_Set, wbMasterDataSet)
            if (mds) {
                self.WB_ProductHierarchy.WB_MasterDataSetRow = mds
                self.WB_ProductHierarchy.cif.WB_MDSET_ID = wbMasterDataSet
            }
        }

        // Set Source
        let wbSource = self.CreateOptions?.wbSourceId || self.LoadOptions?.wbSourceId
        if (_.isNumber(wbSource)) {
            let src: WB_SourceRow = <any>await self.dbContext.find(esWB_Source, wbSource)
            if (src) {
                self.WB_ProductHierarchy.cif.SOURCE_ID = src.cif.SOURCE_ID
            }
        }

    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading ProductHierarchy (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "ProductHierarchy already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new ProductHierarchy.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            if ("RecordResolver" in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve();
            } else {
                recordResolver = ProductHierarchyBO.createRecordResolver({
                    dbContext: self.dbContext
                });
                recordResolverLoadPromise = ProductHierarchyBO.setupRecordResolver(recordResolver, [anId]);
            }

            recordResolverLoadPromise
                .then(() => {
                    const aProductHierarchyRow: any = recordResolver.get(esWB_Product_Hierarchy, anId);

                    if(_.isEmpty(aProductHierarchyRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_ProductHierarchy = aProductHierarchyRow;
                    self.Identity.setAll(self.WB_ProductHierarchy.cif.WB_PRDH_ID, self.WB_ProductHierarchy.cif.WB_PRD_HIER_ID, self.WB_ProductHierarchy.cif.WB_PRD_HIER_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_ProductHierarchy, 'WB_PRDH_ID','WB_PRD_HIER_ID','WB_PRD_HIER_NAME')

                })
                .then(() => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_ProductHierarchy.cif.WB_PRD_HIER_NAME + "(" + self.WB_ProductHierarchy.cif.WB_PRD_HIER_ID + ")");
        try {

            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate ProductHierarchy.";
                self.ValidateProgressProvider.exception(sError);
                throw sError;
            }

            await  ProductHierarchyBOValidations.ValidateFields(self)
            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self._bIsValidated = false;
            } else {
                self._bIsValidated = true;
            }
            self.ValidateProgressProvider.finish();
        } catch (err) {
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);

        }
        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbProductHierarchy = <IwbProductHierarchy>self.drWB_ProductHierarchy;
        this.SaveProgressProvider.start("Saving " + wbProductHierarchy.WB_PRD_HIER_NAME + "(" + wbProductHierarchy.WB_PRD_HIER_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save ProductHierarchy.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            let tasks: Promise<any>[] = [];
            let bDone = false;
            self.Validate({})
                .then((ignore) => {
                    if (!self.bIsValidated) {
                        self._bIsSaved = false;
                        bDone = true;
                        self.SaveProgressProvider.finish();
                        resolve(self);
                        return;
                    }
                }).then((ignore)=> {
                if (bDone) return
                return saveFunction(esWB_Product_Hierarchy, self.drWB_ProductHierarchy,{})
                .then(() => {
                    tasks.push(saveFunction(esWB_Product_Hierarchy_Level, self.WB_ProductHierarchy.WB_ProductHierarchyLevelRows));
                    tasks.push(saveFunction(esWB_Product_Hierarchy_SalesArea, self.WB_ProductHierarchy.WB_ProductHierarchySalesAreaRows))
                    return Promise.all(tasks);
                })
                .then((ignored) => {
                    if (bDone) return;
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        })
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbProductHierarchy = <IwbProductHierarchy>self.drWB_ProductHierarchy;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbProductHierarchy.WB_PRD_HIER_NAME + "(" + wbProductHierarchy.WB_PRD_HIER_ID + ")");
        return new Promise<IBusinessObject>( async (resolve, error) => {

            // 1. Validate if we can delete the ProductHierarchy

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ProductHierarchy.markDeleted()
            _.forEach(self.drWB_ProductHierarchy.WB_ProductHierarchySalesAreaRows,(a) => a.markDeleted())
            _.forEach(self.drWB_ProductHierarchy.WB_ProductHierarchyLevelRows,(a) => a.markDeleted())


            // const query: any = {where: {WB_PRODH_ID: wbProductHierarchy.cif.WB_PRDH_ID}};
            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "Sales Area">

    _salesAreasChanged: BehaviorSubject<ProductHierarchyBO>

    IHaveSalesAreas_init() {
        this._salesAreasChanged = new BehaviorSubject<ProductHierarchyBO>(this)
    }

    get SalesAreasChanged(): BehaviorSubject<ProductHierarchyBO> {
        return this._salesAreasChanged
    }

    async addSalesArea(wbSalesAreaId: number): Promise<WB_ProductHierarchySalesAreaRow> {
        const self = this

        for (let rel of self.WB_ProductHierarchy.WB_ProductHierarchySalesAreaRows) {
            if (!rel.isActive)
                continue
            if (rel.cif.WB_SALESAREA_ID == wbSalesAreaId)
                return rel
        }

        let saRow: WB_SalesAreaRow = await self.dbContext.find(esWB_SalesArea, wbSalesAreaId)
        if (_.isEmpty(saRow))
            return undefined

        if (saRow.cif.WB_SALESORG_ID > 0) {
            let soRow: WB_SalesOrgRow = <any>await self.dbContext.find(esWB_SalesOrg, saRow.cif.WB_SALESORG_ID)
            if (!_.isEmpty(soRow) && _.isEmpty(saRow.WB_SalesOrgRow)) {
                saRow.WB_SalesOrgRow = soRow
            }
        }

        if (saRow.cif.WB_DIVISION_ID > 0) {
            let dvRow: WB_DivisionRow = <any>await self.dbContext.find(esWB_Division, saRow.cif.WB_DIVISION_ID)
            if (!_.isEmpty(dvRow) && _.isEmpty(saRow.WB_DivisionRow)) {
                saRow.WB_DivisionRow = dvRow
            }
        }

        if (saRow.cif.WB_DISTRIBCHANNEL_ID > 0) {
            let dcRow: WB_DistribChannelRow = <any>await self.dbContext.find(esWB_DistribChannel, saRow.cif.WB_DISTRIBCHANNEL_ID)
            if (!_.isEmpty(dcRow) && _.isEmpty(saRow.WB_DistribChannelRow)) {
                saRow.WB_DistribChannelRow = dcRow
            }
        }

        let newRow: WB_ProductHierarchySalesAreaRow = <any>await self.dbContext.createRecordWithKey(esWB_Product_Hierarchy_SalesArea)
        newRow.setDefaults()
        newRow.WB_ProductHierarchyRow = self.WB_ProductHierarchy
        newRow.cif.WB_PRDH_ID = self.WB_ProductHierarchy.cif.WB_PRDH_ID
        newRow.WB_SalesAreaRow = saRow
        newRow.cif.WB_SALESAREA_ID = wbSalesAreaId

        self.SalesAreasChanged.next(self)
        return newRow
    }

    async removeSalesArea(wbPrdHSRId: number): Promise<void> {
        const self = this

        for (let rel of self.WB_ProductHierarchy.WB_ProductHierarchySalesAreaRows) {
            if (!rel.isActive)
                continue
            if (rel.cif.WB_PRDHSR_ID == wbPrdHSRId) {
                rel.markDeleted()
                break
            }
        }

        self.SalesAreasChanged.next(self)
    }

    //</editor-fold>


    //<editor-fold desc="IHaveRecordResolver -- static">
    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        const opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ("dbContext" in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const product_hierarchy_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        };

        return new ESRecordResolver(dbContext, product_hierarchy_options);
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            recordResolver
                .findAllWithRelationships(esWB_Product_Hierarchy, ids)
                .then(() => {
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    //</editor-fold>

    //<editor-fold desc = "Product Hierarchy Level operations">
    addProductHierarchyLevel(options?: any): Promise<ProductHierarchyBO> {
        const self = this;
        return new Promise<ProductHierarchyBO>((resolve, reject) => {
            return self.dbContext.createRecordWithKey(esWB_Product_Hierarchy_Level)
                .then((aNewRow: WB_ProductHierarchyLevelRow) => {
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_PRDH_ID = self.WB_ProductHierarchy.cif.WB_PRDH_ID;
                    self.dbContext.add(esWB_Product_Hierarchy_Level, aNewRow);
                    resolve(self);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    removeProductHierarchyLevel(aLevelRowId: number, options?: any): Promise<ProductHierarchyBO> {
        const self = this;
        return new Promise<ProductHierarchyBO>((resolve, reject) => {
            _.forEach(self.WB_ProductHierarchy.WB_ProductHierarchyLevelRows, (aLevelRow: WB_ProductHierarchyLevelRow) => {
                if (aLevelRow.isActive && aLevelRow.cif.WB_PRDH_LEVEL_ID === aLevelRowId) {
                    aLevelRow.markDeleted();
                }
            });
            resolve(self);
        });
    }
    //</editor-fold>
};
PAEnvironment.registerBusinessObjectClass( ProductHierarchyBO , "ProductHierarchyBO", "Product Hierarchy")